import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';
import ManageLocationForm from '../../../components/SiteAdmin/ManageLocation/ManageLocationForm';
export class AddLocation extends Component {

  render() {
    return (
      <ManageLocationForm />
    )
  }
}



export default compose(
  injectIntl
)(AddLocation)
